import { inferRouteObject } from 'react-router-typed-object';

import { Navigate } from '@/js/libs/router';
import { PrivateRoute, Roles, and, not, or } from '@/js/libs/use-auth';

import Publishers from 'src/scenes/Publishers';
import { searchParams as trafficDashboardSearchParams } from 'src/scenes/Publishers/containers/Traffic/containers/TrafficDashboard/schema';
import Status from 'src/scenes/Status';

const index = true;

export const publishersRouteObject = inferRouteObject({
  path: 'publishers',
  element: (
    <PrivateRoute
      roles={or(Roles.ADMIN, and(Roles.PUBLISHER, not(or(Roles.POSTNETZ_BRANCH_USER, Roles.READ_ONLY_POSTNETZ_BRANCH_USER))))}
      noAccessComponent={Status.NotFound}
    />
  ),
  children: [
    {
      Component: Publishers.Helmet,
      children: [
        {
          children: [
            {
              element: <PrivateRoute roles={Roles.PUBLISHER} noAccessComponent={Status.NotFound} />,
              children: [
                { index, element: <Navigate to='./overview' replace /> },
                { path: 'overview', Component: Publishers.Overview },
                { path: 'campaigns', Component: Publishers.Campaigns },
                {
                  path: 'payouts',
                  Component: Publishers.Payouts.Layout,
                  children: [
                    { index, element: <Navigate to='./statistics' replace /> },
                    { path: 'statistics', Component: Publishers.Payouts.Statistics },
                    { path: 'documents', Component: Publishers.Payouts.Documents },
                  ],
                },
                {
                  path: 'exclusions',
                  Component: Publishers.Exclusions.Layout,
                  children: [
                    { index, element: <Navigate to='./excluded-campaigns' replace /> },
                    { path: 'excluded-campaigns', Component: Publishers.Exclusions.ExcludedCampaigns },
                    { path: 'excluded-customers', Component: Publishers.Exclusions.ExcludedCustomers },
                  ],
                },
                {
                  path: 'traffic',
                  element: <PrivateRoute roles={Roles.ADMIN} noAccessComponent={Status.NotFound} />,
                  children: [
                    {
                      Component: Publishers.Traffic.Layout,
                      children: [
                        { index, element: <Navigate to='./dashboard' replace /> },
                        {
                          path: 'dashboard',
                          searchParams: trafficDashboardSearchParams.parse,
                          Component: Publishers.Traffic.TrafficDashboard,
                        },
                        { path: 'placement-groups', Component: Publishers.Traffic.PlacementGroups },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              element: <PrivateRoute roles={Roles.CONFIGURE_ADS_TXT} noAccessComponent={Status.NotFound} />,
              children: [
                {
                  path: 'ads-config',
                  Component: Publishers.AdsConfig,
                },
              ],
            },
            {
              element: <PrivateRoute roles={Roles.ADMIN} noAccessComponent={Status.NotFound} />,
              children: [
                {
                  path: 'ads-config-v2',
                  Component: Publishers.AdsConfigV2.Layout,
                  children: [
                    { index, element: <Navigate to='./configs' replace /> },
                    { path: 'configs', Component: Publishers.AdsConfigV2.ConfigsList },
                    { path: 'blocks', Component: Publishers.AdsConfigV2.BlocksList },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});
